// extracted by mini-css-extract-plugin
var _1 = "BookChapterMenu__alex--l_tJH";
var _2 = "BookChapterMenu__announcer--BKhAK";
var _3 = "BookChapterMenu__announcer2--dcQBS";
var _4 = "BookChapterMenu__arrow--GHstH";
var _5 = "BookChapterMenu__arrowLeft--x9vKo BookChapterMenu__arrow--GHstH";
var _6 = "BookChapterMenu__arrowRight--KmOwj BookChapterMenu__arrow--GHstH";
var _7 = "BookChapterMenu__border--TtS14";
var _8 = "BookChapterMenu__carpool--DUyIF";
var _9 = "BookChapterMenu__channel5--UbUHV";
var _a = "BookChapterMenu__chapterTitle--v8eMc BookChapterMenu__itemTitle--zhzKl LibraryGeneral__robotoSlab--CmKt3 CoreGeneral__robotoSlab--X8lgW";
var _b = "BookChapterMenu__clod--UKHIp";
var _c = "BookChapterMenu__closed--qN_EC BookChapterMenu__main--ORixV";
var _d = "BookChapterMenu__fiona--iki_I";
var _e = "BookChapterMenu__front--JFHrU";
var _f = "BookChapterMenu__grogg--wu0sJ";
var _10 = "BookChapterMenu__grok--Y3ywW";
var _11 = "BookChapterMenu__headmaster--PgS9Q";
var _12 = "BookChapterMenu__itemTitle--zhzKl LibraryGeneral__robotoSlab--CmKt3 CoreGeneral__robotoSlab--X8lgW";
var _13 = "BookChapterMenu__kitchentable--og9eR";
var _14 = "BookChapterMenu__kraken--cHIfh";
var _15 = "BookChapterMenu__lizzie--WZwOJ";
var _16 = "BookChapterMenu__lunch--H7K8k";
var _17 = "BookChapterMenu__main--ORixV";
var _18 = "BookChapterMenu__mainSlim--Xe8sV";
var _19 = "BookChapterMenu__mathbowl--HR3pE";
var _1a = "BookChapterMenu__mathmeet--H3iWl";
var _1b = "BookChapterMenu__ms_levans--UeHub";
var _1c = "BookChapterMenu__nav--x2_cp";
var _1d = "BookChapterMenu__open--QWTL6 BookChapterMenu__main--ORixV";
var _1e = "BookChapterMenu__pneumatube--yhJWW";
var _1f = "BookChapterMenu__q--QuQwp";
var _20 = "BookChapterMenu__recess--f6pKP";
var _21 = "BookChapterMenu__rg--VIeFX";
var _22 = "BookChapterMenu__rote--LnYXY";
var _23 = "BookChapterMenu__schoolbus--LOx6g";
var _24 = "BookChapterMenu__sectionBg--At0S0";
var _25 = "BookChapterMenu__sectionFlat--EzesE";
var _26 = "BookChapterMenu__sectionQuad--Xuet2";
var _27 = "BookChapterMenu__sectionTitle--cuQgB BookChapterMenu__itemTitle--zhzKl LibraryGeneral__robotoSlab--CmKt3 CoreGeneral__robotoSlab--X8lgW";
var _28 = "BookChapterMenu__sections--ym0bB";
var _29 = "BookChapterMenu__ship--Wevo7";
var _2a = "BookChapterMenu__titleBg--vy2pG";
var _2b = "BookChapterMenu__titleText--fZzq1";
var _2c = "BookChapterMenu__toggle--c7lSU";
var _2d = "BookChapterMenu__toggleOct--taWgn";
var _2e = "BookChapterMenu__training--uzPqw";
var _2f = "BookChapterMenu__unknown--IZIRq";
var _30 = "BookChapterMenu__winnie--maUnS";
var _31 = "BookChapterMenu__wringer--qbmJO";
export { _1 as "alex", _2 as "announcer", _3 as "announcer2", _4 as "arrow", _5 as "arrowLeft", _6 as "arrowRight", _7 as "border", _8 as "carpool", _9 as "channel5", _a as "chapterTitle", _b as "clod", _c as "closed", _d as "fiona", _e as "front", _f as "grogg", _10 as "grok", _11 as "headmaster", _12 as "itemTitle", _13 as "kitchentable", _14 as "kraken", _15 as "lizzie", _16 as "lunch", _17 as "main", _18 as "mainSlim", _19 as "mathbowl", _1a as "mathmeet", _1b as "ms_levans", _1c as "nav", _1d as "open", _1e as "pneumatube", _1f as "q", _20 as "recess", _21 as "rg", _22 as "rote", _23 as "schoolbus", _24 as "sectionBg", _25 as "sectionFlat", _26 as "sectionQuad", _27 as "sectionTitle", _28 as "sections", _29 as "ship", _2a as "titleBg", _2b as "titleText", _2c as "toggle", _2d as "toggleOct", _2e as "training", _2f as "unknown", _30 as "winnie", _31 as "wringer" }
